import React, { useEffect, useState } from 'react'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip, Button, Input, Col, FormGroup, Label } from 'reactstrap'
import styled from 'styled-components'
import Proxies from 'Components/proxies'
import { currencyFormatter } from 'Util/currencyFormatter'
import { Link } from 'react-router-dom'

const { GET, POST } = Proxies

const StyledSpan = styled.span`
  margin: 0px 15px !important;
`
export default function AdminToBeInvoiced() {
  const [loading, setLoading] = useState(false)
  const [brands, setBrands] = useState([])
  const [creatingInvoiceRows, setCreatingInvoiceRows] = useState({})

  const markInvoicingCompleted = (completed, InvoiceID) => {
    POST('invoices/markAsCompleted', { completed: +completed, InvoiceID: +InvoiceID }).then(() => {
      fetchInvoices()
    })
  }
  const fetchInvoices = () => {
    setLoading(true)
    GET('invoices/latestInvoices')
      .then(responseJSON => {
        if (responseJSON.length) {
          setBrands([
            ...responseJSON,
            {
              brandName: 'Total',
              latestClosedInvoice: responseJSON.reduce((acc, cur) => acc + (cur.latestClosedInvoice || 0), 0),
              latestClosedInvoiceBasis: responseJSON.reduce((acc, cur) => acc + (cur.latestClosedInvoiceBasis || 0), 0)
            }
          ])
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const createInvoice = invoicePayload => {
    const invoiceData = {
      BrandID: invoicePayload.BrandID,
      InvoiceID: invoicePayload.InvoiceID,
      latestClosedInvoice: invoicePayload.latestClosedInvoice,
      latestClosedInvoiceBasis: invoicePayload.latestClosedInvoiceBasis,
      excludeFreight: invoicePayload.excludeFreight,
      invoicingCompleted: invoicePayload.invoicingCompleted,
      EconomicNumber: invoicePayload.EconomicNumber
    }
    const invoiceRowId = invoicePayload.InvoiceID

    setCreatingInvoiceRows(prev => ({
      ...prev,
      [invoiceRowId]: true
    }))

    POST('invoices/createInvoicesInEconomic', { invoicePayload: invoiceData })
      .then(resp => {
        const economicInvoiceNumber = resp?.package?.invoiceNumber || resp?.invoiceNumber

        if (!economicInvoiceNumber) {
          return
        }

        setBrands(prevBrands => prevBrands.map(brand => (brand.InvoiceID === invoiceRowId ? { ...brand, economicInvoiceNumber } : brand)))
      })
      .finally(() => {
        setCreatingInvoiceRows(prev => {
          const nextState = { ...prev }
          delete nextState[invoiceRowId]
          return nextState
        })
      })
  }

  const openEconomicInvoice = InvoiceID => {
    window.open(`https://secure.e-conomic.com/sales/invoicing/invoices/${InvoiceID}`, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    fetchInvoices()
  }, [])

  return loading ? (
    <FontAwesomeIcon icon={'spinner'} spin />
  ) : (
    <CollapsibleCard startOpen header={<strong>Invoices to Raise</strong>}>
      <DynamicTable
        responsive
        data={brands}
        headers={{
          InvoiceID: 'InvoiceID',
          brandName: 'Brand',
          latestClosedInvoice: 'Latest Closed Amount',
          latestClosedInvoiceBasis: 'Latest Closed Basis'
        }}
        headerscss={{
          latestClosedInvoice: { textAlign: 'right', whiteSpace: 'nowrap' },
          latestClosedInvoiceBasis: { textAlign: 'right', whiteSpace: 'nowrap' }
        }}
        options={{
          addField: e => {
            const isCreatingInvoice = !!creatingInvoiceRows[e.InvoiceID]

            return e.BrandID ? (
              <td>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip target={'view' + e.BrandID}>Vis</Tooltip>
                  <Button disabled={isCreatingInvoice} tag={Link} to={`/admininvoice/${e.BrandID}/${e.InvoiceID}`} id={'view' + e.BrandID}>
                    <FontAwesomeIcon icon='eye' />
                  </Button>
                  <Button disabled={e.economicInvoiceNumber || isCreatingInvoice} onClick={() => createInvoice(e)}>
                    <FontAwesomeIcon icon={isCreatingInvoice ? 'spinner' : 'file-invoice'} spin={isCreatingInvoice} />
                  </Button>
                  <Button disabled={!e.economicInvoiceNumber || isCreatingInvoice} onClick={() => openEconomicInvoice(e.economicInvoiceNumber)}>
                    <FontAwesomeIcon icon='external-link-alt' />
                  </Button>
                  <Col>
                    <FormGroup check>
                      <Input
                        id='invoiceCheckbox'
                        name='checkbox'
                        type='checkbox'
                        checked={e.invoicingCompleted}
                        onChange={event => markInvoicingCompleted(event.target.checked, e.InvoiceID)}
                      />
                      <Label check for='invoiceCheckbox'>
                        Mark Done
                      </Label>
                    </FormGroup>
                  </Col>
                </div>
              </td>
            ) : null
          },
          fieldFunctions: {
            brandName: e => {
              return <span style={{ fontWeight: e.brandName === 'Total' ? 'bold' : undefined }}>{e.brandName}</span>
            },
            latestClosedInvoice: e => {
              return (
                <StyledSpan style={{ fontWeight: e.brandName === 'Total' ? 'bold' : undefined }}>
                  {e.latestClosedInvoice ? currencyFormatter.format(e.latestClosedInvoice) : '0,00 kr.'}
                </StyledSpan>
              )
            },
            latestClosedInvoiceBasis: e => {
              return (
                <StyledSpan style={{ fontWeight: e.brandName === 'Total' ? 'bold' : undefined }}>
                  {e.latestClosedInvoice ? currencyFormatter.format(e.latestClosedInvoiceBasis) : '0,00 kr.'}
                </StyledSpan>
              )
            }
          },
          fieldExportFunctions: {
            latestClosedInvoice: e => {
              return e.latestClosedInvoice ? currencyFormatter.format(e.latestClosedInvoice) : '0,00 kr.'
            },
            latestClosedInvoiceBasis: e => {
              return e.latestClosedInvoice ? currencyFormatter.format(e.latestClosedInvoiceBasis) : '0,00 kr.'
            }
          }
        }}
      />
    </CollapsibleCard>
  )
}
